import { Box, Skeleton, Stack, StackProps } from '@mui/material'
import React from 'react'


ListSkeleton.defaultProps = {
    length: 8,
    height: 40,
}
function ListSkeleton({ length, height, stackProps }: { length?: number, height?: number, stackProps?: StackProps }) {
    return (
        <Stack spacing={1} p={2} {...stackProps}>
            {[...Array(length)].map((e, i) => (
                <Skeleton sx={{ borderRadius: 1 }} variant="rectangular" width={'100%'} height={height} key={i}></Skeleton>
            ))}
        </Stack>
    )
}

export default ListSkeleton